import cx from 'classnames';

type OwnProps = {
  big?: boolean;
  width: number;
};

export default function Skeleton({ big = false, width }: OwnProps) {
  return (
    <div className={cx('h-24', { 'm:h-32': big })} style={{ width }}>
      <div className="h-full bg-grey-1" />
    </div>
  );
}
